import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReadPersonTypesRequestDto as RequestDto,
  ReadPersonTypesResponseDto as ResponseDto,
} from "../../api/personTypes/list/dtos";
import { PersonType } from "../../models";
import { PagingMeta } from "../../models/_system";
import { Api } from "../../api";

interface Data {
  data: PersonType[];
  meta: PagingMeta;
}
export const list = new EndpointRequest<RequestDto, ResponseDto, Data>(
  "LIST_PERSON_TYPES",
  Api.personTypes.list,
  ({ data: { data, meta } }) => {
    return {
      data: data.map((i) => new PersonType(i)),
      meta: new PagingMeta(meta),
    };
  }
);
